import { useParams, Navigate } from "react-router-dom";
import { Seo } from "../components/onix/Seo";
import { LegalLayout } from "../components/onix/LegalLayout";
import { getLegalPages } from "../data/legal";
import { useLang } from "../i18n/LanguageContext";

export default function LegalPage({ slug }) {
  const params = useParams();
  const { lang } = useLang();
  const key = slug || params.slug;
  const page = getLegalPages(lang)[key];
  if (!page) return <Navigate to="/404" replace />;
  return (
    <>
      <Seo title={`${page.title} | ONIX`} description={page.description} path={`/${key}`} />
      <LegalLayout page={page} />
    </>
  );
}
